<template>
  <div class="-fragment">
    <div class="-thumbnail-wrapper">
      <div
        class="-thumbnail"
        @click="previewVideoAsset"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
      >
        <wt-asset-overlay
          :date="publicationDate"
          :dateFull="publicationDateFull"
          :show-play-icon="!selected && !hover"
          :is-asset-restricted="isAssetRestricted"
          :restrictions-text="assetRestrictions"
        >
          <span slot="append-right" class="-duration">
            <span v-if="selected">▶︎</span>
            <span v-else>{{ duration }}</span>
          </span>
        </wt-asset-overlay>
        <a href="#">
          <img v-if="!showVideo || !canPlay" :src="mixinSrc(src)" />
          <video
            v-if="showVideo"
            :src="this.asset.metadata.providerLowResAssetUrl"
            autoplay
            @canplay="canPlay = true"
            loop
            muted
          ></video>
        </a>
        <slot name="checkmark"></slot>
      </div>
      <footer :title="footerTitle">
        <span class="-title">{{ footerTitle }}</span>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  data() {
    return {
      hover: false,
      canPlay: false,
    };
  },

  watch: {
    showVideo(newVal) {
      if (!newVal) {
        this.canPlay = false;
      }
    },
  },

  computed: {
    src: function () {
      const srcNoGif =
        this.asset.thumbnail ||
        this.asset.metadata.thumbnail256x144Url ||
        this.asset.metadata.thumbnail160x90Url ||
        this.asset.metadata.posterUrl;
      if (this.hover) {
        return this.asset.metadata.animatedGifUrl || srcNoGif;
      }
      return srcNoGif;
    },
    showVideo() {
      return (
        this.hover &&
        !!app.assetType.isDynamicProvider(this.asset) &&
        !!this.asset.metadata.providerLowResAssetUrl
      );
    },
    duration() {
      if (!this.asset.metadata.duration) {
        return '';
      }
      return app.moment.utc(this.asset.metadata.duration * 1000).format('m:ss');
    },
    footerTitle() {
      return this.asset.metadata.title || this.asset.metadata.caption;
    },
  },

  methods: {},
});
</script>
